// extracted by mini-css-extract-plugin
module.exports = {"Press":"Press_Press__YDHMP","content":"Press_content__smabC"};